const quantities = [...document.querySelectorAll('.js-quantity')];

quantities.map(quantity => {
    const input = quantity.querySelector('.js-quantity-input');
    const select = quantity.querySelector('.js-quantity-select');

    if(select) {
        const moreValue = select.getAttribute('data-more');

        if (input && select) {
            const changeHandler = () => {
                if (+select.value >= moreValue) {
                    select.remove();

                    quantity.classList.remove('input--select');
                    input.setAttribute('name', 'quantity');
                    input.setAttribute('type', 'text');
                    input.focus();
                    input.setSelectionRange(input.value.length, input.value.length);
                    input.setAttribute('type', 'number');
                    input.parentElement.classList.add('px-3');
                }
            }

            //changeHandler();
            select.addEventListener('change', changeHandler);
        }
    }
});
